export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-array/src/constant.js
// module id = ../../../../d3-array/src/constant.js
// module chunks = 4